export const isSelectedOption = (options: Array<any> | undefined, currentId: number | string): boolean => !!options && !!options.find(({ id }) => id === +currentId);
